/* Beetroot Alevia-style PDP bundle — vanilla port of Alevia el-* behaviors.
   Meo twist: each offer box maps to its own subscription variant (+ Stay.ai selling plan)
   and its own one-time variant, instead of Alevia's single-variant ± plan model. */
(function () {
  'use strict';
  if (window.__btAleviaInit) return;
  window.__btAleviaInit = true;

  /* ---------- gallery (replaces slick) ---------- */
  function initGallery() {
    if (window.__fsSlick) return; /* slick (Alevia-identical) owns the gallery */
    var main = document.querySelector('.product-offer__main-slider');
    var nav = document.querySelector('.product-offer__nav-slider');
    if (!main || !nav) return;
    var slides = Array.prototype.slice.call(main.querySelectorAll('img'));
    var thumbs = Array.prototype.slice.call(nav.querySelectorAll('img'));
    if (!slides.length) return;
    var idx = 0;
    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.style.display = k === idx ? 'block' : 'none'; });
      thumbs.forEach(function (t, k) { t.classList.toggle('bt-thumb-active', k === idx); });
      var active = thumbs[idx];
      if (active && active.scrollIntoView) {
        try { active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) {}
      }
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = document.querySelector('.product-offer__button-carousel.btn-prev');
    var next = document.querySelector('.product-offer__button-carousel.btn-next');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    /* pointer events cover mouse drag AND touch swipe; touch-action keeps
       vertical page scroll native while horizontal drags reach us */
    main.style.touchAction = 'pan-y';
    main.style.cursor = 'grab';
    var startX = null, startY = null;
    main.addEventListener('pointerdown', function (e) { startX = e.clientX; startY = e.clientY; }, { passive: true });
    main.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? idx + 1 : idx - 1);
      startX = null;
    }, { passive: true });
    main.addEventListener('pointercancel', function () { startX = null; });
    main.addEventListener('dragstart', function (e) { e.preventDefault(); });
    show(0);
  }

  /* ---------- offer boxes / cart ---------- */
  function initOffer() {
    var items = document.querySelectorAll('.product-offer__variant-item');
    var variantInput = document.getElementById('selected-variant-id');
    var buyNowBtn = document.getElementById('buy-now');
    if (!items.length || !variantInput || !buyNowBtn) return;
    var form = buyNowBtn.closest('form');
    var subscriptionWrapper = document.getElementById('subscription-wrapper');
    var subscriptionCheckbox = document.getElementById('offer-subscription');
    var checklistWrapper = document.querySelector('.product-offer__info-checklist');
    var checklistItems = checklistWrapper ? checklistWrapper.querySelectorAll('.product-offer__checklist-item .value') : [];
    var buyOnceBtn = document.getElementById('product-offer__buy-once-btn');
    var buyOncePrice = document.querySelector('[data-buy-once-price]');
    var btnPrice = buyNowBtn.querySelector('.btn-price');
    var btnCompare = buyNowBtn.querySelector('.btn-compare');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); });

    function selected() { return document.querySelector('.product-offer__variant-item.selected'); }
    function isSub(sel) {
      return !!(sel && sel.dataset.sellingPlanId) && (!subscriptionCheckbox || subscriptionCheckbox.checked);
    }

    function updatePrices() {
      var sel = selected();
      if (!sel) return;
      var hasPlan = !!sel.dataset.sellingPlanId;
      if (subscriptionWrapper) {
        if (hasPlan) subscriptionWrapper.classList.remove('hidden-display');
        else { if (subscriptionCheckbox) subscriptionCheckbox.checked = false; subscriptionWrapper.classList.add('hidden-display'); }
      }
      var sub = isSub(sel);
      items.forEach(function (item) {
        var priceEl = item.querySelector('.price');
        var compareEl = item.querySelector('.compare-price');
        var savingEl = item.querySelector('.product-offer__variant-saving');
        var price = sub ? item.dataset.subscriptionPrice : item.dataset.onetimePrice;
        var savings = sub ? item.dataset.savingsSub : item.dataset.savings;
        if (priceEl) priceEl.textContent = price;
        if (savingEl && savings) savingEl.textContent = savings;
        if (compareEl) compareEl.textContent = item.dataset.comparePrice;
      });
      variantInput.value = sub ? sel.dataset.subVariantId : sel.dataset.onetimeVariantId;
      var planInput = document.getElementById('selected-selling-plan');
      if (planInput) planInput.value = sub ? sel.dataset.sellingPlanId : '';
      if (btnPrice) { var np = sub ? sel.dataset.subscriptionPrice : sel.dataset.onetimePrice; if (btnPrice.textContent !== np) btnPrice.textContent = np; }
      if (btnCompare) {
        if (sel.dataset.comparePrice) { btnCompare.textContent = sel.dataset.comparePrice; btnCompare.style.display = 'inline'; }
        else btnCompare.style.display = 'none';
      }
      if (buyOncePrice && sel.dataset.onetimePrice) buyOncePrice.textContent = sel.dataset.onetimePrice;
    }

    function updateChecklist() {
      if (!checklistItems.length) return;
      var sel = selected();
      if (!sel) return;
      var selectedIndex = Array.prototype.indexOf.call(items, sel);
      checklistItems.forEach(function (item) {
        var rawText = item.dataset.originalValue || item.textContent.trim();
        if (!item.dataset.originalValue) item.dataset.originalValue = rawText;
        var parts = rawText.split('|').map(function (p) { return p.trim(); });
        var row = item.closest('.product-offer__checklist-item');
        if (parts.length === 1) { item.textContent = parts[0]; row.style.display = ''; return; }
        if (parts[selectedIndex]) { item.textContent = parts[selectedIndex]; row.style.display = ''; }
        else row.style.display = 'none';
      });
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        items.forEach(function (v) { v.classList.remove('selected'); });
        item.classList.add('selected');
        updatePrices();
        updateChecklist();
      });
    });
    if (subscriptionCheckbox) subscriptionCheckbox.addEventListener('change', updatePrices);

    function addAndCheckout(payload, btn) {
      btn.classList.add('loading');
      btn.setAttribute('disabled', true);
      var label = btn.querySelector('.btn-text') || btn;
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function (r) {
          if (!r.ok) throw new Error('clear failed ' + r.status);
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed ' + r.status);
          return r.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          console.error('[bt-alevia]', err);
          btn.classList.remove('loading');
          btn.removeAttribute('disabled');
          var original = label.textContent;
          label.textContent = 'SOMETHING WENT WRONG — TAP TO RETRY';
          setTimeout(function () { label.textContent = original; }, 4000);
        });
    }

    buyNowBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var sel = selected();
      if (!sel) return;
      var payload;
      if (isSub(sel)) payload = { id: Number(sel.dataset.subVariantId), quantity: 1, selling_plan: Number(sel.dataset.sellingPlanId) };
      else payload = { id: Number(sel.dataset.onetimeVariantId), quantity: 1 };
      addAndCheckout(payload, buyNowBtn);
    });

    if (buyOnceBtn) buyOnceBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var sel = selected();
      if (!sel) return;
      addAndCheckout({ id: Number(sel.dataset.onetimeVariantId), quantity: 1 }, buyOnceBtn);
    });

    window.addEventListener('pageshow', function () {
      [buyNowBtn, buyOnceBtn].forEach(function (btn) {
        if (btn) { btn.classList.remove('loading'); btn.disabled = false; }
      });
    });

    updatePrices();
    updateChecklist();
  }

  /* ---------- stock date ---------- */
  function initStock() {
    var stockMsg = document.querySelector('.product-offer__stock-message');
    if (!stockMsg) return;
    var daysToAdd = parseInt(stockMsg.getAttribute('data-days'), 10) || 5;
    var futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + daysToAdd);
    function getOrdinal(n) {
      if (n > 3 && n < 21) return n + 'th';
      switch (n % 10) { case 1: return n + 'st'; case 2: return n + 'nd'; case 3: return n + 'rd'; default: return n + 'th'; }
    }
    var month = futureDate.toLocaleString('en-US', { month: 'long' });
    var innerSpan = stockMsg.querySelector('span:not([class])') || stockMsg.querySelector('span');
    if (innerSpan) innerSpan.innerHTML += ' <span class="date">' + month + ' ' + getOrdinal(futureDate.getDate()) + '</span>';
  }

  /* ---------- sticky CTA (Alevia-style bottom bar: show after buy box, hide at footer) ---------- */
  function initSticky() {
    var stickyDiv = document.querySelector('.product-offer__sticky');
    var wrapper = document.querySelector('.product-offer__wrapper');
    if (!stickyDiv || !wrapper) return;
    var stickyBtn = stickyDiv.querySelector('.product-offer__sticky-btn');
    var footer = document.querySelector('.site-footer') || document.querySelector('.m-footer') || document.querySelector('footer');
    function handleScroll() {
      var passed = wrapper.getBoundingClientRect().bottom <= 0;
      var footerTouching = false;
      if (footer) {
        var footerRect = footer.getBoundingClientRect();
        var stickyRect = stickyDiv.getBoundingClientRect();
        footerTouching = stickyRect.bottom >= footerRect.top;
      }
      if (passed && !footerTouching) stickyDiv.classList.add('visible');
      else stickyDiv.classList.remove('visible');
    }
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    if (stickyBtn) stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var link = this.dataset.link;
      if (link && link.trim() !== '') { window.location.href = link; return; }
      var target = document.querySelector('#product-offer');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
    handleScroll();
  }

  /* ---------- accordions (buy-box description + FAQ) ---------- */
  function initAccordions() {
    var items = document.querySelectorAll('.faq-accordion__item');
    items.forEach(function (item) {
      var trigger = item.querySelector('.faq-accordion__item-title');
      var content = item.querySelector('.faq-accordion__item-description');
      if (!trigger || !content) return;
      content.style.height = '0px';
      content.style.overflow = 'hidden';
      content.style.paddingBottom = '0px';
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          if (other !== item) {
            var oc = other.querySelector('.faq-accordion__item-description');
            other.classList.remove('is-open');
            if (oc) { oc.style.height = '0px'; oc.style.paddingBottom = '0px'; }
          }
        });
        if (isOpen) {
          content.style.height = '0px';
          content.style.paddingBottom = '0px';
          item.classList.remove('is-open');
        } else {
          item.classList.add('is-open');
          content.style.height = 'auto';
          var fullHeight = content.scrollHeight + 'px';
          content.style.height = '0px';
          requestAnimationFrame(function () {
            content.style.height = fullHeight;
            content.style.paddingBottom = '20px';
          });
        }
      });
    });
  }

  /* ---------- survey counters ---------- */
  function initCounters() {
    var counters = document.querySelectorAll('.progress-counter__item-counter');
    if (!counters.length) return;
    function animateCount(el, target) {
      var startTime = performance.now();
      function step(currentTime) {
        var progress = Math.min((currentTime - startTime) / 1500, 1);
        el.textContent = Math.floor(progress * target) + '%';
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target + '%';
      }
      requestAnimationFrame(step);
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var targetValue = parseInt(el.getAttribute('data-percentage'), 10);
          if (!el.classList.contains('counted')) { el.classList.add('counted'); animateCount(el, targetValue); }
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(function (c) { observer.observe(c); });
  }

  /* ---------- timeline reveal ---------- */
  function initTimeline() {
    var journeyItems = document.querySelectorAll('.progress-timeline__item');
    if (!journeyItems.length) return;
    var lastScrollY = window.scrollY, queue = [], processing = false;
    function processQueue() {
      if (processing || queue.length === 0) return;
      processing = true;
      queue.shift().classList.add('active');
      setTimeout(function () { processing = false; processQueue(); }, 800);
    }
    var observer = new IntersectionObserver(function (entries) {
      var currentScrollY = window.scrollY;
      var isScrollingDown = currentScrollY > lastScrollY;
      entries.forEach(function (entry) {
        var target = entry.target;
        if (entry.isIntersecting) {
          if (!target.classList.contains('active') && queue.indexOf(target) === -1) { queue.push(target); processQueue(); }
        } else if (!isScrollingDown) target.classList.remove('active');
      });
      lastScrollY = currentScrollY;
    }, { threshold: 1 });
    journeyItems.forEach(function (item) { observer.observe(item); });
  }

  function init() {
    initGallery();
    initOffer();
    initStock();
    initSticky();
    initAccordions();
    initCounters();
    initTimeline();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
